import { CohabitationAnscNotificationsCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import RegisterCohabitationNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-cohabitation/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const RegisterCohabitationNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <RegisterCohabitationNotificationCivilStatusShared
        items={CohabitationAnscNotificationsCancellationsCrumbs()}
        scope={IdAmbito.Cancellazioni}
      />
    </Fragment>
  );
};

RegisterCohabitationNotificationCivilStatusPage.displayName =
  'Research Cohabitation Notifications Detail Page component';

export default RegisterCohabitationNotificationCivilStatusPage;
